import { createSelector } from 'reselect';
import { GeneralPortfolioProductSubscriptionType } from '@mews-commander/data-access';

import { ExtendedEnterprise } from '../../ducks/enterprises';
import { getCurrentEnterprise } from './enterprise';

const getCurrentEnterpriseProductSubscriptions = createSelector(
    getCurrentEnterprise,
    (enterprise: ExtendedEnterprise) => enterprise.portfolioProductSubscriptionTypes
);

// Special "Access Control" type of portfolio. It has portfolio subscription, but only SSO subscription product (not MMP).
// Used for chains like YHA that have multiple properties, are not using MMP, but still want to use SSO + user provisioning.
export const hasCurrentEnterpriseSsoAccessOnly = createSelector(
    getCurrentEnterpriseProductSubscriptions,
    (portfolioProductSubscriptions) =>
        portfolioProductSubscriptions?.includes(GeneralPortfolioProductSubscriptionType.SingleSignOn) &&
        !portfolioProductSubscriptions?.includes(GeneralPortfolioProductSubscriptionType.MultiProperty)
);

export const hasCurrentEnterpriseSsoAccess = createSelector(
    getCurrentEnterpriseProductSubscriptions,
    (portfolioProductSubscriptions) =>
        portfolioProductSubscriptions?.includes(GeneralPortfolioProductSubscriptionType.SingleSignOn)
);

export const hasCurrentEnterpriseMultiPropertyAccess = createSelector(
    getCurrentEnterpriseProductSubscriptions,
    (portfolioProductSubscriptions) =>
        portfolioProductSubscriptions?.includes(GeneralPortfolioProductSubscriptionType.MultiProperty)
);
